/**
 * Scroll-based Image Animation for BIAT Section (Product & Tech Pages)
 * Animates through image sequence based on scroll position
 */

const imageUrls = [
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00000.png?v=1700137578',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00001.png?v=1700137578',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00002.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00003.png?v=1699544214',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00004.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00005.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00006.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00007.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00008.png?v=1700137578',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00009.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00010.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00011.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00012.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00013.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00014.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00015.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00016.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00017.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00018.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00019.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00020.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00021.png?v=1700137577',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00022.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00023.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00024.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00025.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00026.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00027.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00028.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00029.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00030.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00031.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00032.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00033.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00034.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00035.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00036.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00037.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00038.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00039.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00040.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00041.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00042.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00043.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00044.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00045.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00046.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00047.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00048.png?v=1699544215',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00049.png?v=1699544216',
  'https://cdn.shopify.com/s/files/1/0765/4283/7072/files/bang_explode_blackhat_00050.png?v=1699544216'
];

class BIATScrollAnimation {
  constructor() {
    this.images = [];
    this.currentIndex = 0;
    this.targetIndex = 0;
    this.isAnimating = false;
    this.lastScrollTop = 0;
    this.easingFactor = window.innerWidth <= 768 ? 0.12 : 0.08; // Slower, smoother transitions
    this.lastFrameTime = 0;
    this.frameInterval = 1000 / 30; // Target 30 FPS
    this.isInView = false;
    this.sectionElement = null;
    this.animatedImageElement = null;
    this.animatedWrapperElement = null;
    
    this.init();
  }

  init() {
    // Support both legacy BIAT markup and current innovation-manifesto markup
    this.sectionElement = document.querySelector('.biat-section, .innov2-outer, .innovation-section');
    if (!this.sectionElement) {
      return;
    }

    this.animatedImageElement = this.sectionElement.querySelector('#animatedImage');
    this.animatedWrapperElement = this.sectionElement.querySelector('#animatedDiv');

    if (!this.animatedImageElement) {
      return;
    }

    this.setupIntersectionObserver();
    this.setupScrollHandler();
    this.animate();
    
    // Initial check
    setTimeout(() => {
      this.handleScroll();
    }, 100);
  }

  setupIntersectionObserver() {
    const options = {
      threshold: 0.1,
      rootMargin: '100px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        this.isInView = entry.isIntersecting;
        if (this.isInView) {
          // Lazy load images when element enters viewport
          this.preloadImages();
        }
      });
    }, options);

    if (this.animatedImageElement) {
      observer.observe(this.animatedImageElement);
    }
  }

  preloadImages() {
    // Progressive loading: load first 10 immediately, then load rest progressively
    const loadCount = Math.min(10, imageUrls.length);
    for (let i = 0; i < loadCount; i++) {
      if (!this.images[i]) {
        const img = new Image();
        img.src = imageUrls[i];
        img.onload = () => {
          this.images[i] = img;
        };
      }
    }

    // Load remaining images progressively
    setTimeout(() => {
      for (let i = loadCount; i < imageUrls.length; i++) {
        if (!this.images[i]) {
          const img = new Image();
          img.src = imageUrls[i];
          img.onload = () => {
            this.images[i] = img;
          };
        }
      }
    }, 100);
  }

  setupScrollHandler() {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  handleScroll() {
    if (!this.isInView) return;
    
    if (!this.animatedWrapperElement && !this.animatedImageElement) return;

    // Use the animated element itself, not the entire section
    const element = this.animatedWrapperElement || this.animatedImageElement;
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const elementHeight = rect.height;
    const elementTop = rect.top;
    const elementBottom = rect.bottom;
    
    // Calculate visible portion of element in viewport
    // Progress: 0 = element entering from bottom, 1 = element exiting from top
    let progress = 0;
    
    if (elementBottom < 0) {
      // Element is completely above viewport - animation complete
      progress = 1;
    } else if (elementTop > windowHeight) {
      // Element is completely below viewport - animation not started
      progress = 0;
    } else {
      // Element is partially or fully in viewport
      // Calculate how much of the element has scrolled through viewport
      const visibleTop = Math.max(0, elementTop);
      const visibleBottom = Math.min(windowHeight, elementBottom);
      const visibleHeight = visibleBottom - visibleTop;
      
      // Calculate progress based on element's center position relative to viewport
      // When center is at bottom of viewport: progress = 0
      // When center is at top of viewport: progress = 1
      const elementCenter = elementTop + (elementHeight / 2);
      const viewportCenter = windowHeight / 2;
      
      // Animation range: viewport height + element height for smoother transition
      const animationRange = windowHeight + elementHeight;
      const distanceFromViewportBottom = windowHeight - elementCenter;
      
      // Normalize progress: 0 to 1 as element scrolls through viewport
      progress = Math.max(0, Math.min(1, distanceFromViewportBottom / animationRange));
    }
    
    // Map progress to image index (0 to 50)
    this.targetIndex = Math.round(progress * (imageUrls.length - 1));
    this.isAnimating = true;
  }

  animate() {
    const currentTime = performance.now();
    const deltaTime = currentTime - this.lastFrameTime;

    if (deltaTime >= this.frameInterval) {
      if (this.isAnimating) {
        const diff = this.targetIndex - this.currentIndex;
        if (Math.abs(diff) > 0.01) {
          this.currentIndex += diff * this.easingFactor;
          const frameIndex = Math.round(this.currentIndex);
          const imgElement = this.animatedImageElement;
          
          if (imgElement && frameIndex >= 0 && frameIndex < imageUrls.length) {
            imgElement.src = imageUrls[frameIndex];
          }
        } else {
          this.isAnimating = false;
          this.currentIndex = this.targetIndex;
        }
      }
      this.lastFrameTime = currentTime;
    }

    requestAnimationFrame(() => this.animate());
  }
}

// Initialize - scripts are conditionally loaded by Liquid template
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BIATScrollAnimation();
  });
} else {
  new BIATScrollAnimation();
}

